import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STAGES = [
  { key: "boq_sales_order", label: "BOQ/Sales Order" },
  { key: "designs", label: "Designs" },
  { key: "token_advance", label: "Token Advance" },
  { key: "planning", label: "Planning" },
  { key: "execution", label: "Execution" },
  { key: "pre_installation", label: "Pre-Installation" },
  { key: "installation", label: "Installation" },
  { key: "pending_handover", label: "Pending Handover" },
  { key: "completed", label: "Completed" },
  { key: "amc_service", label: "AMC / Service" },
  { key: "lost", label: "Lost / Dropped" },
];

export const TERMINAL_STAGES = ["completed", "amc_service", "lost"];

export const LOST_REASONS = [
  { key: "price", label: "Price too high" },
  { key: "timeline", label: "Timeline mismatch" },
  { key: "competitor", label: "Went with competitor" },
  { key: "ghosted", label: "Ghosted / no reply" },
  { key: "scope_change", label: "Scope changed" },
  { key: "budget_cut", label: "Budget cut / postponed" },
  { key: "other", label: "Other" },
];

export const FUNCTIONS = [
  "sales", "design", "procurement", "installation", "service",
  "finance", "marketing", "architect", "franchise", "admin",
];

export const TASK_STATUSES = [
  { key: "not_started", label: "Not Started", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  { key: "in_progress", label: "In Progress", color: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  { key: "waiting", label: "Waiting", color: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  { key: "completed", label: "Completed", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  { key: "blocked", label: "Blocked", color: "bg-red-500/20 text-red-300 border-red-500/30" },
];

export const PRIORITIES = [
  { key: "low", label: "Low", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  { key: "medium", label: "Medium", color: "bg-sky-500/20 text-sky-300 border-sky-500/30" },
  { key: "high", label: "High", color: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  { key: "critical", label: "Critical", color: "bg-red-500/20 text-red-300 border-red-500/30" },
];

export const ROLES = [
  "admin", "sales", "design", "procurement", "installation",
  "service", "finance", "marketing", "store_partner",
];

export const roleLabel = (r) =>
  ({ admin: "Admin", sales: "Sales", design: "Design/BOQ", procurement: "Procurement",
     installation: "Installation", service: "Service", finance: "Finance",
     marketing: "Marketing", store_partner: "Store Partner" }[r] || r);

export const stageLabel = (s) => STAGES.find((x) => x.key === s)?.label || s;

export const PROJECT_SOURCES = [
  { key: "walk_in", label: "Walk-in" },
  { key: "google_search", label: "Google Search" },
  { key: "website", label: "Website" },
  { key: "instagram", label: "Instagram" },
  { key: "youtube", label: "YouTube" },
  { key: "customer_referral", label: "Customer Referral" },
  { key: "architect", label: "Architect / Designer" },
  { key: "team_referral", label: "Team Referral" },
  { key: "existing_client", label: "Existing Client" },
];

export const PROJECT_COMMITMENTS = [
  { key: "token_advance", label: "Token Advance" },
  { key: "sales_order_approved", label: "Sales Order Approved" },
];

export const DRAWINGS_STATUSES = [
  { key: "yet_to_start", label: "Yet to Start", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  { key: "in_progress", label: "In Progress", color: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  { key: "approval_pending", label: "Approval Pending", color: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  { key: "approved", label: "Approved", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
];

export const PAYMENT_MODES = [
  { key: "bank_transfer", label: "Bank Transfer" },
  { key: "upi", label: "UPI" },
  { key: "cheque", label: "Cheque" },
  { key: "cash", label: "Cash" },
  { key: "card", label: "Card" },
];

export const inr = (n) => {
  if (n == null) return "—";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export function formatErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
